import { Button } from "primereact/button";
import { useState } from "react";
import PresentationView from "./PresentationView";

const PrivatePresentation = () => {
  const [selectedPresentation, setSelectedPresentation] =
    useState("PRESENTATION 1");
  const [subTitleForTheSlide, setSubTitleForTheSlide] = useState(false);

  return (
    <div className="mt-3">
      <Button
        label={"PRESENTATION 1"}
        onClick={() => setSelectedPresentation("PRESENTATION 1")}
        style={{
          background:
            selectedPresentation === "PRESENTATION 1" ? "#002133" : "#fff",
          border: 0,
          borderRadius: "2px",
          color: selectedPresentation === "PRESENTATION 1" ? "#fff" : "#002133",
        }}
      />

      <Button
        label={"PRESENTATION 2"}
        onClick={() => setSelectedPresentation("PRESENTATION 2")}
        style={{
          background:
            selectedPresentation === "PRESENTATION 2" ? "#002133" : "#fff",
          border: 0,
          borderRadius: "2px",
          color: selectedPresentation === "PRESENTATION 2" ? "#fff" : "#002133",
        }}
      />

      {selectedPresentation === "PRESENTATION 1" ? (
        <PresentationView
          isSlideChecked={true}
          idx={1}
          handleSlideCheck={() => {}}
          slideCheckedValue={"slide1"}
          slideName={"Slide 1"}
          subTitleForTheSlide={subTitleForTheSlide}
          handleSubTitleForTheSlide={(value) => setSubTitleForTheSlide(value)}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default PrivatePresentation;
